import { render, staticRenderFns } from "./TwitterItem.vue?vue&type=template&id=76668090&"
import script from "./TwitterItem.vue?vue&type=script&lang=js&"
export * from "./TwitterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports